import { history } from 'authentication/_helpers/history';

const LOGIN_PATH = '/user/login-page';
const INTERNAL_API_PREFIXES = [
    process.env.REACT_APP_API_URL,
    process.env.REACT_APP_HOME_URL,
    process.env.REACT_APP_IMAGE_SUBMIT_API_URL
].filter(Boolean);

function getStoredUser() {
    const rawUser = localStorage.getItem('user');

    if (!rawUser) {
        return null;
    }

    try {
        return JSON.parse(rawUser);
    } catch (error) {
        localStorage.removeItem('user');
        return null;
    }
}

function getStoredToken() {
    const user = getStoredUser();

    return user && user.token ? user.token : null;
}

function hasStoredSession() {
    return Boolean(getStoredToken());
}

function clearStoredUser() {
    localStorage.removeItem('user');
}

function redirectToLogin() {
    if (history.location && history.location.pathname === LOGIN_PATH) {
        return;
    }

    history.push(LOGIN_PATH);
}

function redirectIfSessionMissing() {
    if (hasStoredSession()) {
        return false;
    }

    clearStoredUser();
    redirectToLogin();
    return true;
}

function getResponseStatus(source) {
    if (typeof source === 'number') {
        return source;
    }

    if (!source) {
        return null;
    }

    if (typeof source.status === 'number') {
        return source.status;
    }

    if (source.response && typeof source.response.status === 'number') {
        return source.response.status;
    }

    return null;
}

function isUnauthorizedError(source) {
    return getResponseStatus(source) === 401;
}

function isInternalApiRequest(url) {
    if (!url || typeof url !== 'string') {
        return false;
    }

    if (url.startsWith('/')) {
        return true;
    }

    return INTERNAL_API_PREFIXES.some(prefix => url.startsWith(prefix));
}

function logoutIfUnauthorized(source) {
    if (!isUnauthorizedError(source)) {
        return false;
    }

    const hadSession = Boolean(localStorage.getItem('user'));

    clearStoredUser();
    redirectToLogin();

    return hadSession;
}

function getJsonAuthConfig(extraConfig = {}) {
    const token = getStoredToken();

    if (!token) {
        return null;
    }

    const { headers, ...restConfig } = extraConfig;

    return {
        ...restConfig,
        headers: {
            'X-Id-Token': token,
            'Content-Type': 'application/json',
            ...(headers || {})
        }
    };
}

export {
    clearStoredUser,
    getJsonAuthConfig,
    getResponseStatus,
    getStoredToken,
    getStoredUser,
    isInternalApiRequest,
    isUnauthorizedError,
    logoutIfUnauthorized,
    redirectIfSessionMissing,
    redirectToLogin
};
